// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__tKikE","load5":"Spinner_load5__91MPz"};